import { render, staticRenderFns } from "./PaysTable.vue?vue&type=template&id=1db60a16&"
import script from "./PaysTable.vue?vue&type=script&lang=ts&"
export * from "./PaysTable.vue?vue&type=script&lang=ts&"
import style0 from "./PaysTable.vue?vue&type=style&index=0&id=1db60a16&prod&lang=css&"
import style1 from "./PaysTable.vue?vue&type=style&index=1&id=1db60a16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports